export const PERMISSION_REF_NGSI_DATA_CONSUMER = 'ngsi_data_consumer';
